// extracted by mini-css-extract-plugin
export default {"searchTagsWrapp":"SearchLocationInput_searchTagsWrapp__OgUGq","locationTags":"SearchLocationInput_locationTags__mAyuW"};